import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { Input } from '@/components/Form'
import useECCN from '../../useECCN'

const ECCNDetailModal = ({ modalDetail, setModalDetail }) => {
  const { show, isCreate, detail } = modalDetail

  const methods = useForm({
    defaultValues: {
      country: '',
      code: '',
      description: '',
    },
  })

  const { useCreateECCN, useUpdateECCN } = useECCN()
  const createECCN = useCreateECCN()
  const updateECCN = useUpdateECCN()

  useEffect(() => {
    if (detail && !isCreate) {
      methods.reset({
        country: detail.country || '',
        code: detail.code || '',
        description: detail.description || '',
      })
    } else {
      methods.reset({
        country: '',
        code: '',
        description: '',
      })
    }
  }, [detail, isCreate, methods])

  const onClose = () => {
    setModalDetail({ show: false })
    methods.reset()
  }

  const onSubmit = async (data) => {
    try {
      if (isCreate) {
        await createECCN.mutateAsync(data)
      } else {
        await updateECCN.mutateAsync({
          id: detail._id,
          data,
        })
      }
      onClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal isOpen={show} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{isCreate ? 'Create' : 'Edit'} ECCN</ModalHeader>
        <ModalCloseButton />
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalBody>
              <Flex direction="column" gap={4}>
                <Input name="country" label="Country" isRequired />
                <Input name="code" label="Code" isRequired />
                <Input name="description" label="Description" />
              </Flex>
            </ModalBody>
            <ModalFooter>
              <Spacer />
              <Button variant="ghost" mr={3} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="blue" type="submit" isLoading={createECCN.isLoading || updateECCN.isLoading}>
                {isCreate ? 'Create' : 'Update'}
              </Button>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default ECCNDetailModal
